import React, { useCallback, useEffect, useState } from "react";
import { adminApi } from "../lib/api";
import { usePubSocket } from "../lib/usePubSocket";
import StaffLoginGate from "../components/StaffLoginGate";
import { RevenuePanel, AlertsPanel } from "../components/StaffPanels";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Button } from "../components/ui/button";
import { DhunLogo, AivigoFooter } from "../components/DhunLogo";
import { Loader2, LogOut } from "lucide-react";

export default function Admin() {
  const [authed, setAuthed] = useState(() => !!localStorage.getItem("dd_admin_token"));
  const [pub, setPub] = useState(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const onUnauth = () => { setAuthed(false); setPub(null); };
    window.addEventListener("dd:admin-unauth", onUnauth);
    return () => window.removeEventListener("dd:admin-unauth", onUnauth);
  }, []);

  useEffect(() => {
    if (!authed) return;
    adminApi.get("/auth/staff/me").then(({ data }) => setPub(data.pub)).catch(() => setAuthed(false));
  }, [authed]);

  usePubSocket(pub?.id, useCallback((m) => {
    if (["alert", "revenue_update"].includes(m.type)) setTick((t) => t + 1);
  }, []));

  const logout = () => {
    localStorage.removeItem("dd_admin_token");
    setAuthed(false);
    setPub(null);
  };

  if (!authed) return <StaffLoginGate role="admin" heading="Pub admin login" onLogin={() => setAuthed(true)} />;
  if (!pub) {
    return <div className="flex min-h-screen items-center justify-center bg-[#0B0E14]"><Loader2 className="h-6 w-6 animate-spin text-violet-400" /></div>;
  }

  return (
    <div className="min-h-screen bg-[#0B0E14] text-white" data-testid="admin-dashboard">
      <header className="border-b border-white/5">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <div className="flex items-center gap-3">
            <DhunLogo size={40} />
            <div>
              <p className="text-[10px] uppercase tracking-widest text-violet-300">Pub admin</p>
              <p className="text-lg font-extrabold" data-testid="admin-pub-name">{pub.name}</p>
            </div>
          </div>
          <Button variant="ghost" size="sm" onClick={logout} data-testid="admin-logout-button" className="border border-white/10">
            <LogOut className="mr-1 h-3 w-3" /> Sign out
          </Button>
        </div>
      </header>
      <div className="mx-auto max-w-6xl px-6 py-6">
        <Tabs defaultValue="revenue">
          <TabsList className="border border-white/10 bg-[#131822]">
            <TabsTrigger value="revenue" data-testid="admin-tab-revenue">Revenue</TabsTrigger>
            <TabsTrigger value="alerts" data-testid="admin-tab-alerts">Alerts</TabsTrigger>
          </TabsList>
          <TabsContent value="revenue" className="mt-5"><RevenuePanel client={adminApi} pubId={pub.id} tick={tick} /></TabsContent>
          <TabsContent value="alerts" className="mt-5"><AlertsPanel client={adminApi} pubId={pub.id} tick={tick} /></TabsContent>
        </Tabs>
        <AivigoFooter className="mt-12" />
      </div>
    </div>
  );
}
